import React from 'react';
import { shelf as c } from '../../component-classes';

type PagingButtonProps = {
    className?: string;
    icon: React.ReactNode;
    label: string;
    onClick?: () => void;
    style?: React.CSSProperties;
};

function PagingButton(props: PagingButtonProps) {
    const { className = '', icon, label, onClick, style } = props;
    return (
        <button
            className={`${c.pagingButton} ${className}`}
            onClick={onClick}
            style={style}
        >
            <span className="sr-only">{label}</span>
            {icon}
        </button>
    );
}

export default PagingButton;
